import { MatSvgIcon } from '../types/mat-svg-icon';

export const deviceTypeIcons = new Map<string, MatSvgIcon>([
    ['casRtu', { icon: 'air', isSvg: false }],
    ['rtu', { icon: 'air', isSvg: false }],
    ['rtuLink', { icon: 'air', isSvg: false }],
    ['directFired', { icon: 'air', isSvg: false }],
    ['ibt', { icon: 'air', isSvg: false }],
    ['energyMonitoring', { icon: 'bolt', isSvg: false }],
    ['coreBoard', { icon: 'device-fire-extinguisher', isSvg: true }],
    ['lightingControl', { icon: 'online_prediction', isSvg: false }],
    ['ecpm03', { icon: 'device-hood', isSvg: true }],
    ['dcv2', { icon: 'device-hood', isSvg: true }],
    ['scs', { icon: 'device-hood', isSvg: true }],
    ['hvls', { icon: 'device-fan', isSvg: true }],
    ['module', { icon: 'router', isSvg: false }],
]);
